import { createReducer } from '@reduxjs/toolkit';

import getListingCompatibilityList, {
  setListingCompatibilityList
} from '../../thunks/Compatibility/getListingCompatibilityList';

const initialState = {
  loading: false,
  error: '',
  data: null,
};

const getListingCompatibilityListReducer = createReducer(initialState, {
  [getListingCompatibilityList.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getListingCompatibilityList.fulfilled]: (state, { payload: data }) => ({
    ...state,
    loading: false,
    data,
  }),
  [setListingCompatibilityList]: (state, { payload: data }) => ({
    ...state,
    data
  }),
  [getListingCompatibilityList.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    data: null
  }),
});

export default getListingCompatibilityListReducer;
